
import AppClientHeading from "@/components/layout-editor/ClientHeading.vue";
import AppHeading from "@/components/layout-editor/Heading.vue";
import AppLogo from "@/components/layout-editor/Logo.vue";
import AppPage from "@/components/layout-editor/Page.vue";
import AppSectionSplitter from "@/components/layout-editor/SectionSplitter.vue";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import { mmToPx } from "@/utils/screen";
import Vue from "vue";
import AppRequirements from "./Requirements.vue";
import AppSaleTable from "./SaleTable.vue";
import AppTotals from "./Totals.vue";
import AppFreeBlock from "./FreeBlock.vue";
import { FreeBlock } from "@/utils/documents/free-block";
import { Sale } from "@/models/base";
import { ILayoutImage } from "@/utils/layout-editor";
import { RequirementsLocation } from "@/utils/sale-layouts/requirements";
import AppFreeLine from "./FreeLine.vue";
import { SaleLayoutFreeLine } from "@/utils/sale-layouts/free-line";

export default Vue.extend({
	props: {
		layout: {
			type: Object as () => SaleLayout,
			required: true
		},
		zoomLevel: Number,
		lang: String,
		showGrid: Boolean,
		contactGroupId: {
			type: Number,
			required: true
		},
		exampleDocument: {
			type: Object as ()=>Sale,
		}
	},
	computed: {
		headerLogos(): ILayoutImage[] {
			return this.layout.getLogosByPlacement("Heading");
		},
		bodyLogos(): ILayoutImage[] {
			return this.layout.getLogosByPlacement("Body");
		},
		footerLogos(): ILayoutImage[] {
			return this.layout.getLogosByPlacement("Footer");
		},
		headerFreeBlocks():FreeBlock[] {
			return this.layout.getFreeBlocksByPlacement("Heading");
		},
		bodyFreeBlocks():FreeBlock[] {
			return this.layout.getFreeBlocksByPlacement("Body");
		},
		footerFreeBlocks():FreeBlock[]{
			return this.layout.getFreeBlocksByPlacement("Footer");
		},
		bodyHeight(): number {
			let pageSettings = this.layout.PageSettings;
			let totalHeight = pageSettings.Height - pageSettings.MarginTop - pageSettings.MarginBottom;
			return totalHeight - this.layout.PageSettings.HeadingHeight;
		},
		outerBodyHeight(): number {
			return this.layout.PageSettings.Height - this.layout.PageSettings.HeadingHeight;
		},
		bodyWidth(): number {
			return mmToPx(this.bodyWidthMm);
		},
		bodyWidthMm(): number {
			let pageSettings = this.layout.PageSettings;
			return pageSettings.Width - pageSettings.MarginLeft - pageSettings.MarginRight;
		},
		showRequirements():boolean {
			return this.layout.Requirements.Location == RequirementsLocation.AFTER_TOTALS;
		},
		aboveTableFreeLines():SaleLayoutFreeLine[]{
			return this.layout.FreeLines.filter(f=>f.Placement == "AboveTable");
		}
	},
	watch: {
		"layout.Bardcodes": {
			deep: true,
			handler(){
				console.log("Barcodes changed");
			}
		}
	},
	methods: {
		mmToPx
	},
	components: {
		AppHeading,
		AppClientHeading,
		AppSaleTable,
		AppTotals,
		AppRequirements,
		AppLogo,
		AppPage,
		AppSectionSplitter,
		AppFreeBlock,
		AppFreeLine
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
